var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "p-2 bg-secondary-1 rounded" }, [
      _c("div", { staticClass: "p-3 bg-white rounded" }, [
        _c("div", { staticClass: "row d-flex align-items-center" }, [
          _c("div", { staticClass: "col-12 col-md" }, [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(0),
              _c("div", [
                _c("div", { staticClass: "data-name" }, [_vm._v("Aceptados:")]),
                _c("div", { staticClass: "fs-22 lh-1 text-green" }, [
                  _vm._v(" " + _vm._s(_vm.value.accepted || "00") + " ")
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md" }, [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(1),
              _c("div", [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Monto Aceptado:")
                ]),
                _c("div", { staticClass: "fs-22 lh-1 text-green" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.acceptedAmount ?? 0)) +
                      " "
                  )
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md" }, [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(2),
              _c("div", [
                _c("div", { staticClass: "data-name" }, [_vm._v("Denegados:")]),
                _c("div", { staticClass: "fs-22 lh-1 text-warning" }, [
                  _vm._v(" " + _vm._s(_vm.value.denied || "00") + " ")
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md" }, [
            _c("div", { staticClass: "d-flex" }, [
              _vm._m(3),
              _c("div", [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Monto Denegado:")
                ]),
                _c("div", { staticClass: "fs-22 lh-1 text-warning" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.deniedAmount ?? 0)) +
                      " "
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c("i", { staticClass: "fas fa-file-user text-green fs-40" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-green rounded-circle d-flex justify-content-center align-items-center dim-40"
        },
        [_c("i", { staticClass: "fas fa-dollar-sign text-white fa-lg" })]
      )
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c("i", { staticClass: "fas fa-file-user text-warning fs-40" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mr-2" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-warning rounded-circle d-flex justify-content-center align-items-center dim-40"
        },
        [_c("i", { staticClass: "fas fa-dollar-sign text-white fa-lg" })]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }